import React, {useState,useEffect} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {getMyPosts} from '../../services/servicesGetMyPosts';
import {URLIMG} from '../../helpers/constantes';
import {ListaDePosts,ImgPost,DivMyPosts,DivPosts,DivNovoPost} from './SyledMyPosts';
import {IconGrAddCircle} from './SyledMyPosts';
import ButtonTrialVersion from '../../components/ButtonTrialVersion/ButtonTrialVersion';
export default function MyPosts(){
    const history = useHistory();
    const location = useLocation();
    function redirectURL({pathname, state}){
        location.pathname = pathname
    }
    const [post, setPost] = useState([]);
    const [urlImg, setUrlImg] = useState(URLIMG);

    async function carregaPost(){
        const resultPosts = await getMyPosts();
        setPost(resultPosts);
    };

    function redirectURL({pathname, state}){
        location.pathname = pathname
    }


    useEffect(()=>{
        carregaPost();

    },[]);

    return(<DivMyPosts>
            <ButtonTrialVersion />
            <h1 style={{margin:'20px',fontFamily:'Ubuntu'}}>Meus Posts</h1>
            <ListaDePosts >
                <DivPosts>
                    <Link to={{pathname:`/app/newPost`}}>
                        <DivNovoPost style={{border:'1px solid ligthgray'}} onClick={()=>redirectURL({pathname: `/app/newPost`})}>
                            <span style={{fontSize:'26px'}}>Criar Post</span>
                            <IconGrAddCircle />
                        </DivNovoPost>
                    </Link>
                </DivPosts>
                {post.length > 0 ?
                post.map(item=>{
                    return(<DivPosts key={item.Id}>
                        <Link to={{pathname:`/app/postedit/${item.Id}`,state:{pagePreview:'myposts'}}}>
                            <ImgPost alt=''
                                onClick={()=>redirectURL({pathname: `/app/postedit/${item.Id}`,state: {pagePreview:'myposts'}})}
                                id={item.Id.toString()}
                                src={`${urlImg+item.Image1.split('/')[item.Image1.split('/').length - 1]}`}
                            />
                        </Link>
                    </DivPosts>)})
                    :<div></div>}
            </ListaDePosts>
        </DivMyPosts>)
}
